import React, { useState } from 'react';
import Button from './Button';
import api from '../services/api';

const PremiumManager = ({ shop, onUpdate }) => {
  const [customDomain, setCustomDomain] = useState(shop.premiumFeatures.customDomain || '');

  const handleUpdateDomain = async () => {
    try {
      const res = await api.put(`/shops/${shop._id}`, {
        premiumFeatures: { ...shop.premiumFeatures, customDomain },
      });
      onUpdate(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="mt-8 p-4 border rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Funkcje Premium</h2>
      {shop.isPremium ? (
        <div>
          <div className="mb-4">
            <label htmlFor="customDomain" className="block text-sm font-medium text-gray-700">
              Własna domena
            </label>
            <div className="mt-1 flex rounded-md shadow-sm">
              <input
                type="text"
                name="customDomain"
                id="customDomain"
                className="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300"
                value={customDomain}
                onChange={(e) => setCustomDomain(e.target.value)}
                placeholder="www.twoj-sklep.pl"
              />
              <Button onClick={handleUpdateDomain} className="rounded-l-none">
                Zapisz
              </Button>
            </div>
          </div>
          <p>Analityka: {shop.premiumFeatures.analytics ? 'Aktywna' : 'Nieaktywna'}</p>
          <p>Priorytetowe wsparcie: {shop.premiumFeatures.prioritySupport ? 'Aktywne' : 'Nieaktywne'}</p>
        </div>
      ) : (
        <p>Ulepsz do wersji premium, aby odblokować te funkcje.</p>
      )}
    </div>
  );
};

export default PremiumManager;